// extracted by mini-css-extract-plugin
export default {"wrapper":"TextBlock_wrapper__P3ZVs"};